module.exports = __webpack_public_path__ + "img/hotCompany.f3d4252e.png";